/**
 * badgeIconHelper
 *
 * Mapeia categorias de badge para icones e cores game-style.
 * Usa Font Awesome 5+ Free (que ja vem no projeto) com icones tematicos
 * de jogos/conquistas.
 *
 * Pro futuro: pode-se substituir pela CSS class do Kenney Icon Font
 * (228 icones CC0 https://github.com/nicodinh/kenney-icon-font).
 */

export const BADGE_ICONS_BY_CATEGORY = {
  'unit_completion': 'fas fa-check-circle',
  'quiz_performance': 'fas fa-brain',
  'time_dedication': 'fas fa-stopwatch',
  'course_completion': 'fas fa-graduation-cap',
  'special': 'fas fa-star',
  'streak': 'fas fa-fire',
  'social': 'fas fa-users',
  'achievement': 'fas fa-trophy',
  'milestone': 'fas fa-flag-checkered',
  'level': 'fas fa-layer-group',
  'master': 'fas fa-crown',
  'speed': 'fas fa-bolt',
  'precision': 'fas fa-bullseye',
  'creativity': 'fas fa-palette'
};

export const BADGE_COLORS_BY_CATEGORY = {
  'unit_completion': '#28a745',
  'quiz_performance': '#9C27B0',
  'time_dedication': '#FF9800',
  'course_completion': '#dc3545',
  'special': '#FFD700',
  'streak': '#FF5722',
  'social': '#2196F3',
  'achievement': '#E91E63',
  'milestone': '#673AB7',
  'level': '#3F51B5',
  'master': '#FFD700',
  'speed': '#FFC107',
  'precision': '#F44336',
  'creativity': '#00BCD4'
};

export const BADGE_GRADIENTS_BY_CATEGORY = {
  'unit_completion': 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'quiz_performance': 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
  'time_dedication': 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'course_completion': 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'special': 'linear-gradient(135deg, #fcb69f 0%, #ffecd2 100%)',
  'achievement': 'linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)'
};

const DEFAULT_ICON = 'fas fa-award';
const DEFAULT_COLOR = '#FFD700';
const DEFAULT_GRADIENT = 'linear-gradient(135deg, #FFD700 0%, #FFA000 100%)';

/**
 * Retorna o ícone Font Awesome pra uma badge.
 * Prioridade: badge.icon (custom) > categoria > default.
 */
export function getBadgeIcon(badge) {
  if (badge && badge.icon && typeof badge.icon === 'string' && badge.icon.trim()) {
    return badge.icon;
  }
  if (badge && badge.category && BADGE_ICONS_BY_CATEGORY[badge.category]) {
    return BADGE_ICONS_BY_CATEGORY[badge.category];
  }
  return DEFAULT_ICON;
}

/**
 * Retorna cor da badge.
 * Prioridade: badge.color > categoria > default.
 */
export function getBadgeColor(badge) {
  if (badge && badge.color && typeof badge.color === 'string' && badge.color.trim()) {
    return badge.color;
  }
  if (badge && badge.category && BADGE_COLORS_BY_CATEGORY[badge.category]) {
    return BADGE_COLORS_BY_CATEGORY[badge.category];
  }
  return DEFAULT_COLOR;
}

/**
 * Retorna gradient CSS para o card de badge.
 */
export function getCategoryGradient(category) {
  return BADGE_GRADIENTS_BY_CATEGORY[category] || DEFAULT_GRADIENT;
}

export default {
  getBadgeIcon,
  getBadgeColor,
  getCategoryGradient,
  BADGE_ICONS_BY_CATEGORY,
  BADGE_COLORS_BY_CATEGORY,
  BADGE_GRADIENTS_BY_CATEGORY
};
